import { NgModule } from '@angular/core';
import { AdsenseModule } from 'ng2-adsense';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule,ReactiveFormsModule} from '@angular/forms';
import { routing, appRoutingProviders } from './app.routing';
import { HttpModule } from '@angular/http';
import {SlimLoadingBarModule} from 'ng2-slim-loading-bar';
import { MetaModule } from 'ng2-meta';



import { AppComponent } from './app.component';
import { AppService } from './app.service';
import { HomeComponent } from './home/home.component';

import { WelcomeComponent } from './welcome/welcome.component';
import { WelcomeService } from './welcome/welcome.service';

import {ShareService} from './services/services';
import {PageComponent } from './page/page.component';
import {PageHomeComponent } from './page/pagehome.component';
import {PageService} from './page/page.service';

import { CategoryComponent } from './product/category.component';
import { ProductHomeComponent } from './product/producthome.component';
import { CategoryHomeComponent } from './product/categoryhome.component';
import { CategoryService } from './product/category.service';
//ProductComponent,
import { ProductComponent } from './product/product.component';


import { NewsComponent } from './news/news.component';
import { NewsHomeComponent } from './news/newshome.component';
import { NewsDetailComponent } from './news/newsdetail.component';
import { NewsService } from './news/news.service';

import { ServiceComponent } from './service/service.component';
import { ServiceHomeComponent } from './service/servicehome.component';
import { ServiceDetailComponent } from './service/servicedetail.component';
import { ServiceService } from './service/service.service';



import {GalleryComponent } from './gallery/gallery.component';
import {GalleryHomeComponent } from './gallery/galleryhome.component';
import {GalleryService} from './gallery/gallery.service';


import {VideoComponent } from './video/video.component';
//import {VideoHomeComponent } from './gallery/galleryhome.component';
import {VideoService} from './video/video.service';


import {BannerComponent} from './banner/banner.component';
import {BannerService } from './banner/banner.service';

import {ContactComponent} from './contact/contact.component';
import {ContactHomeComponent } from './contact/contacthome.component';
import {ContactService } from './contact/contact.service';

import { AlertComponent } from './_directives/index';
import { CopyWriteComponent } from './_copywrite/index';
import {CopyWriteService} from './services/copywrite.service';
import {AlertService} from './services/alert.service';

import {RoomlistingComponent } from './hotel/roomlisting.component';
import {BookingHomeComponent} from './hotel/bookinghome.component';
import { BookingComponent } from './hotel/booking.component';
import { RoominfoComponent } from './hotel/roominfo.component';
import {RoomlistingService} from './hotel/roomlisting.services';


import { BlogCategoryComponent } from './blog/blogcategory.component';
import { BlogHomeComponent } from './blog/bloghome.component';
import { BlogService } from './blog/blog.service';
import { BlogComponent } from './blog/blog.component';
import { EmbedVideo } from 'ngx-embed-video';

@NgModule({
  imports: [
  	BrowserModule,
  	HttpModule,
  	FormsModule,
  	ReactiveFormsModule,
  	SlimLoadingBarModule.forRoot(),
  	EmbedVideo.forRoot(),
  	MetaModule.forRoot(),  
  		
  	routing
  ],
  declarations: [ 
  	AppComponent,  	
  	PageComponent,
  	PageHomeComponent,
  	AlertComponent,
  	CopyWriteComponent,
  	CategoryComponent, 
  	ProductComponent,
  	CategoryHomeComponent,
  	ProductHomeComponent, 
  	NewsComponent,
  	NewsDetailComponent,
  	NewsHomeComponent,
  	BannerComponent,
  	GalleryComponent,
  	VideoComponent,
  	GalleryHomeComponent,	
  	ContactHomeComponent,
    HomeComponent,
    WelcomeComponent,
    ServiceComponent,
    ServiceHomeComponent,
    ServiceDetailComponent,
    RoomlistingComponent,
    RoominfoComponent,
    BookingHomeComponent,
    BookingComponent,
    ContactComponent,
    BlogCategoryComponent,
    BlogHomeComponent,
    BlogComponent
  ],
  providers: [
  	appRoutingProviders,
  	AppService,
  	AlertService,
  	CopyWriteService,
  	ShareService,
  	PageService,
  	NewsService,
  	GalleryService,
  	VideoService,
  	BannerService,
  	ContactService,
  	ServiceService,
  	WelcomeService,
  	RoomlistingService,
    CategoryService,
    BlogService
  ],
  bootstrap: [
  	AppComponent
  ]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./resources/assets/typescript/app.module.ts